import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2V7H20",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10V6C4 3.79086 5.79086 2 8 2H15L20 7V18C20 20.2091 18.2091 22 16 22V22",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 16L8.4375 18L7.5 17",
			stroke: "currentColor",
			strokeWidth: 1.125,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 17,
			r: 5,
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgDocumentCheck;
